import { COLORS, FONT_SIZES, FONT_WEIGHTS, pickThemeFontStyles } from '@/theme';
import { Button, Menu } from '@/ui';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
`;

export const StyledHeader = styled.div`
  display: flex;
  padding: 1rem 2rem;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid ${COLORS.LIGHT_GRAY};
`;

export const StyledButton = styled(Button)`
  &&& {
    width: 100%;
    margin-bottom: 1rem;
    ${pickThemeFontStyles('14', '18', 'BOLD')};
  }
`;

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
  text-align: left;
  margin: 0;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  padding: 1.5rem 2rem;
  flex-direction: column;
`;

export const StyledActionButton = styled(Button)<{ $color: string }>`
  &&& {
    background: ${({ $color }) => $color};
    padding: 0.25rem;
    border: none;
    width: 2.125rem;
    height: 2.125rem;

    :hover {
      background: ${({ $color }) => $color};
    }
  }

  svg {
    path {
      fill: ${COLORS.WHITE};
    }
  }
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  margin-bottom: 2rem;
`;

export const StyledMenu = styled(Menu)`
  width: 100%;
`;

export const StyledTabLabelWithBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledTabNotificationBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 1.375rem;
  height: 1.375rem;
  padding: 0 0.4375rem;
  border-radius: 0.6875rem;
  background-color: ${COLORS.RED};
  color: ${COLORS.WHITE};
  font-size: ${FONT_SIZES['10']};
  font-weight: ${FONT_WEIGHTS.SEMI_BOLD};
  line-height: 1;
  letter-spacing: 0.01em;
  box-shadow: 0 1px 4px rgba(213, 58, 58, 0.4);
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 2rem 0;
  padding-bottom: 0;
  align-items: start;
  background-color: ${COLORS.GRAY};
  border-bottom: 1px solid ${COLORS.LIGHT_GRAY};
`;
